<template>
	<v-card class='elevation-0 events-page pt-7'>
		<div class='events-page__wrap'>
			<div>
				<div class='d-flex align-center event__search px-4 mb-7'>
					<div class='d-flex w-100 mr-6 align-center' style='width: 100%'>
						<input
							type='text'
							class='post-preview-card__comment'
							placeholder='Search'
							v-model='filters.search'
							@input='filterSearch'
						/>
					</div>
					<img :src='searchIcon' alt='' />
				</div>
			</div>

			<div class='d-flex'>
				<v-skeleton-loader
					width='600'
					v-bind='attrs'
					type='card'
					v-if='false'
				>
				</v-skeleton-loader>
				<FeaturedPost v-else />
			</div>

			<div>
				<div>
					<v-btn
						:key="chipItem.name"
						v-for='chipItem in normalizedFeedFilterChips'
						@click='getAndCallDynamicFunction(chipItem.content)'
						class='post__btn-filters'
						:class="{ 'post__btn-filters-active': isButtonActive(chipItem.content) }"
					>{{ chipItem.name }}
					</v-btn
					>
				</div>
			</div>

			<PostFilterModal
				v-on:closeModal='closeModal'
				:show='showModal'

				entityType='events'

				:error='error'
				:show-error='showError'
				:close-alert='closeAlert'

				:selected-button='selectedButton'
				:currentActiveButtonTitle='currentActiveButtonTitle'
				:current-active-button='this.currentActiveButton'
				@applySelection='applySelection'
				@setItems='setSelectedItems'
				@setCategory='setEventCategory'
				@setDate='setDateTimeRange'
			/>

		</div>

		<div class='d-flex mt-3'>
			<v-skeleton-loader
				v-if='isLoading'
				v-bind='attrs'
				width='600'
				type='list-item, list-item-three-line, card-heading'
			></v-skeleton-loader>
			<div v-else style='width: 100%'>
				<div v-if='this.events.length === 0' class='mt-5'>
					<NewsFeedEmpty
						title='Events is empty at the moment.'
						description='Check back later.'
					/>
				</div>


				<div v-for='{ month, data } in groupedByMonth' :key='month'>
					<div class='events-page__time mb-2'>{{ month }}</div>

					<div v-for='(event, index) in data' :key='index'>
						<EventPreview :event='event' />
					</div>
				</div>

			</div>
		</div>


		<div class='d-flex my-9 justify-center home-page__pagination'
			v-if='!isLoading && events.length > 0'
		>
			<v-pagination
				color='#F2F2F2'
				:total-visible='10'
				circle
				v-model='filters.page'
				:length='+this.pageCountEvents'
				@input='(e) => onPageChange(e)'
			></v-pagination>
		</div>

		<v-btn
			v-show='isVisible'
			@click='scrollToTop'
			bottom
			right
			fixed
			fab
		>
			<v-icon>mdi-chevron-up</v-icon>
		</v-btn>

	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import EventPreview from '@/components/Event/EventPreview'
import searchIcon from '@/assets/images/search.svg'
import PostFilterModal from '@/components/Modals/PostFilterModal'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import _ from 'lodash'

const DEBOUNCE_TIMEOUT = 500


export default {
	name: 'EventsPage',
	components: {
		FeaturedPost,
		EventPreview,
		PostFilterModal,
		NewsFeedEmpty,
	},
	methods: {
		...mapActions('post', ['fetchPosts', 'getFeaturedPost', 'getViolationsList']),
		...mapActions('event', ['fetchEvents', 'clearEventCategories']),

		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		isButtonActive(name) {
			return this.selectedButton.includes(name)
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		pad(number) {
			return (number < 10 ? '0' : '') + number;
		},
		closeAlert() {
			this.showError = false;
			this.error = ''
		},
		convertDateToTimeStamp(date) {
			if (!date) {
				return null
			}

			const dateObject = new Date( date );

			const utcYear = dateObject.getUTCFullYear();
			const utcMonth = this.pad(dateObject.getUTCMonth() + 1);
			const utcDay = this.pad(dateObject.getUTCDate());

			const utcHours = this.pad(dateObject.getUTCHours());
			const utcMinutes = this.pad(dateObject.getUTCMinutes());

			const utcFormatted = utcYear + '-' + utcMonth + '-' + utcDay + ' ' + utcHours + ':' + utcMinutes;

			return  Math.floor( new Date( utcFormatted ).getTime() / 1000)
		},

		clearButtonHandler() {
			this.currentActiveButton = 'clear'
			this.currentActiveButtonTitle = ''
			this.selectedButton = ['clear']
			this.selectedChapters = []

			this.filters = {
				filter: null,
				groups: [],
				tags: [],
				date: {
					to: null,
					from: null,
				},
				categoryId: null,
				search: this.filters.search,
			}
			this.showModal = false
		},
		registerButtonHandler() {
			this.currentActiveButton = 'register'
			const mutuallyExclusiveButtons = ['clear', 'schedule']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			this.filters = {
				...this.filters,
				filter:  isHandleButtonActive ? 'follow' : null,
			}
		},
		scheduleButtonHandler() {
			this.currentActiveButton = 'schedule'
			const mutuallyExclusiveButtons = ['clear', 'register']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			this.filters = {
				...this.filters,
				filter: isHandleButtonActive ? 'schedule' : null,
			}
		},

		tagsButtonHandler() {
			this.currentActiveButton = 'tags'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.content === this.currentActiveButton
			).name

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			this.setActiveButtonTitle()

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedTags = []
				this.filters = {
					...this.filters,
					tags: [],
				}
			}

			this.showModal = isHandleButtonActive
		},
		chaptersButtonHandler() {
			this.currentActiveButton = 'chapters'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.content === this.currentActiveButton
			).name

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			this.setActiveButtonTitle()

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedChapters = []
				this.filters = {
					...this.filters,
					groups: [],
				}
			}

			this.showModal = isHandleButtonActive
		},
		categoryButtonHandler() {
			this.currentActiveButton = 'category'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.content === this.currentActiveButton
			).name

			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			this.setActiveButtonTitle()

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.filters = {
					...this.filters,
					categoryId: null,
				}
			}

			this.showModal = isHandleButtonActive
		},

		dateButtonHandler() {
			this.currentActiveButton = 'date'

			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.content === this.currentActiveButton
			).name

			const mutuallyExclusiveButtons = ['clear', 'past']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			this.setActiveButtonTitle()

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.filters = {
					...this.filters,
					date: {
						from: null,
						to: null
					}
				}

				this.selectedDateRange = {
					from: null,
					to: null
				};
			}

			this.showModal = isHandleButtonActive
		},

		pastButtonHandler() {
			this.currentActiveButton = 'past'
			const mutuallyExclusiveButtons = ['clear', 'date']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			const initDateFilter = {
				from: null,
				to: isHandleButtonActive ? Math.floor(Date.now()) : null
			}

			this.filters = {
				...this.filters,
				date: initDateFilter
			}

			this.selectedDateRange = initDateFilter
		},

		filterSpecifiedValues(list, filterValues) {
			return list.filter(item => !filterValues.includes(item))
		},

		getFilteredChips(
			selectedButtons,
			handleButtonName,
			mutuallyExclusiveButtons
		) {
			const isButtonPresentInlist = this.selectedButton.includes(handleButtonName)

			if (!isButtonPresentInlist) {
				return this.filterSpecifiedValues([...this.selectedButton, handleButtonName], mutuallyExclusiveButtons)
			} else {
				const filteredValues = this.filterSpecifiedValues(this.selectedButton, handleButtonName, [handleButtonName])

				if ( filteredValues.length <= 0 ) {
					return ['clear'];
				}

				return filteredValues;
			}
		},

		getAndCallDynamicFunction(name) {
			const dynamicFunctionName = `${name}ButtonHandler`
			const dynamicFunction = this[dynamicFunctionName]

			if (typeof dynamicFunction === 'function') {
				dynamicFunction()
			} else {
				console.error('Function not found')
			}
		},
		onPageChange(page) {
			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				category_id: this.filters.categoryId,
				to_timestamp: this.convertDateToTimeStamp( this.filters.date.to ),
				from_timestamp: this.convertDateToTimeStamp( this.filters.date.from ),

				tag_ids: this.filters.tags,
				search: this.filters.search,
				page: page,
			}
			const queryString = this.formatFilters(params)
			this.getNews(queryString)
		},

		formatFilters(filters) {
			const {
				filter,
				chapter_id,
				tag_ids,

				category_id,
				from_timestamp,
				to_timestamp,

				search,
				page
			} = filters

			const tagIds = tag_ids.reduce((prev, next) => {
				return `${prev}&tag_ids[]=${next}`
			}, '')

			const groupIds = chapter_id.reduce((prev, next) => {
				return `${prev}&chapter_id[]=${next}`
			}, '')

			let queryString = `&filter=${filter}${tagIds}${groupIds}&page=${page}&sort=event_order`

			const isPastButtonActive = this.selectedButton.includes('past')

			if (isPastButtonActive) {
				queryString = queryString.replace('sort=event_order', 'sort=-event_order')
			}

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}
			if (category_id) {
				queryString += `&category_id=${category_id}`
			}
			if (from_timestamp) {
				queryString += `&from_timestamp=${from_timestamp}`
			}
			if (to_timestamp) {
				queryString += `&to_timestamp=${to_timestamp}`
			}

			return queryString
		},

		async getNews(additionalQueryParams = '') {
			await this.fetchEvents(additionalQueryParams)
		},

		closeModal() {
			this.showModal = false

			const mutuallyExclusiveButtons = ['clear']

			switch (this.currentActiveButton) {
				case 'chapters':
					this.currentActiveButton = 'chapters'

					this.selectedChapters = []
					this.filters = {
						...this.filters,
						groups: [],
					}

					break;
				case 'tags':
					this.currentActiveButton = 'tags'

					this.selectedTags = []
					this.filters = {
						...this.filters,
						tags: [],
					}

					break;
			}

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)
		},

		setSelectedItems(item) {
			const {listItem, selectedType, idColumnName = 'id'} = item

			this.setDynamicItems(listItem, selectedType, idColumnName)
		},
		setDynamicItems(item, selectedType, idColumnName) {
			if (this[selectedType].includes(item[idColumnName])) {
				this[selectedType] = this[selectedType].filter(
					(itemFilter) => itemFilter !== item[idColumnName],
				)
			} else {
				this[selectedType] = [...this[selectedType], item[idColumnName]]
			}
		},
		setDateTimeRange(item) {
			const { date, time, type } = item;

			if (!this.isDateFilterValid(this.selectedDateRange, item)) {
				this.showError = true;
				this.error = `The end date of the filter must be greater than the start date`
			}

			if (this.isDateFilterValid(this.selectedDateRange, item)) {
				this.showError = false;
				this.error = ''
			}

			const range = this.selectedDateRange ?? {from: null, to: null};

			this.selectedDateRange = {...range, [type]: `${date} ${time}`}
		},
		setEventCategory({category}) {
			this.selectedCategory = +category.id
		},

		isDateFilterValid(currentDateRange, dateValue) {
			const {date, time, type} = dateValue
			const {from, to} = currentDateRange || {}

			const isThisEndDateForFullRange = from && (type === 'to');
			const isThisStartDateForFullRange = to && (type === 'from');

			if (isThisEndDateForFullRange) {
				const fromTimestamp = new Date(currentDateRange.from).getTime();
				const toTimestamp = new Date(`${date} ${time}`).getTime()

				return toTimestamp > fromTimestamp
			}

			if (isThisStartDateForFullRange) {
				const fromTimestamp = new Date(`${date} ${time}`).getTime();
				const toTimestamp = new Date(currentDateRange.to).getTime();

				return fromTimestamp < toTimestamp
			}

			return true;
		},
		setChapters(chapter) {
			if (this.selectedChapters.includes(chapter.chapter_id)) {
				this.selectedChapters = this.selectedChapters.filter(
					(item) => item !== chapter.chapter_id,
				)
			} else {
				this.selectedChapters = [...this.selectedChapters, chapter.chapter_id]
			}
		},
		setTags(tag) {
			if (this.selectedTags.includes(tag.tag_id)) {
				this.selectedTags = this.selectedTags.filter((item) => item !== tag.tag_id)
			} else {
				this.selectedTags = [...this.selectedTags, tag.tag_id]
			}
		},

		applySelection() {
			this.filters.groups = this.selectedChapters
			this.filters.tags = this.selectedTags
			this.filters.date = this.selectedDateRange
			this.filters.categoryId = this.selectedCategory

			this.showModal = false
		},

		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,
				tag_ids: this.filters.tags,

				category_id: this.filters.categoryId,
				to_timestamp: this.convertDateToTimeStamp( this.filters.date.to ),
				from_timestamp: this.convertDateToTimeStamp( this.filters.date.from ),

				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getNews(queryString)
			}, DEBOUNCE_TIMEOUT)
		},
		setActiveButtonTitle(){
			this.currentActiveButtonTitle = this.normalizedFeedFilterChips.find(
				item => item.content === this.currentActiveButton
			).name
		}
	},

	created() {
		this.fetchEvents('sort=event_order')
	},

	computed: {
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('event', ['events', 'isLoading', 'pageCountEvents']),
		...mapGetters('tag', ['tags']),
		...mapGetters('settings', ['event']),

		normalizedFeedFilterChips() {
			if (!this.event) {
				return {}
			}

			return this.event.normalizedChips
		},
		groupedByMonth() {
			return Object.values(
				this.events.reduce((acc, item) => {
					const fromDate = new Date(item.event_start * 1000)
					const month = fromDate.toLocaleString('en-US', { month: 'long' })
					const year = fromDate.getFullYear()
					const key = `${month} ${year}`

					if (!acc[key]) {
						acc[key] = { month: key, data: [] }
					}

					acc[key].data.push(item)

					return acc
				}, {}),
			)
		},

	},
	watch: {

		'filters.filter': function(val) {
			const params = {
				filter: val,

				category_id: this.filters.categoryId,
				to_timestamp: this.convertDateToTimeStamp( this.filters.date.to ),
				from_timestamp: this.convertDateToTimeStamp( this.filters.date.from ),

				chapter_id: this.filters.groups,
				tag_ids: this.filters.tags,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getNews(queryString)
		},
		'filters.groups': function(next, prev) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,

				category_id: this.filters.categoryId,
				to_timestamp: this.convertDateToTimeStamp( this.filters.date.to ),
				from_timestamp: this.convertDateToTimeStamp( this.filters.date.from ),

				chapter_id: next,
				tag_ids: this.filters.tags,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getNews(queryString)
		},
		'filters.tags': function(next, prev) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const params = {
				filter: this.filters.filter,

				category_id: this.filters.categoryId,
				to_timestamp: this.convertDateToTimeStamp( this.filters.date.to ),
				from_timestamp: this.convertDateToTimeStamp( this.filters.date.from ),

				chapter_id: this.filters.groups,
				tag_ids: next,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getNews(queryString)
		},

		'filters.categoryId': function(val) {
			const params = {
				filter: this.filters.filter,

				category_id: val,
				to_timestamp: this.convertDateToTimeStamp( this.filters.date.to ),
				from_timestamp: this.convertDateToTimeStamp( this.filters.date.from ),

				chapter_id: this.filters.groups,
				tag_ids: this.filters.tags,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getNews(queryString)
		},

		'filters.date': function(next, prev) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}

			const {from, to} = next;

			const params = {
				filter: this.filters.filter,

				category_id: this.filters.categoryId,
				to_timestamp: this.convertDateToTimeStamp( to ),
				from_timestamp: this.convertDateToTimeStamp( from ),

				chapter_id: this.filters.groups,
				tag_ids: this.filters.tags,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getNews(queryString)
		},

		selectedButton(cur) {
			if (cur.length === 0) {
				this.selectedButton = ['clear']
			}
		},
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		this.clearEventCategories()
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isVisible: false,
			selectedTags: [],
			selectedCategory: null,
			selectedDateRange: {
				from: null,
				to: null
			},
			timer: 0,
			filters: {
				filter: null,

				groups: [],
				tags: [],

				categoryId: null,

				date: {
					from: null,
					to: null
				},

				page: 1,
				search: '',
			},
			searchIcon,
			selectedButton: ['clear'],

			currentActiveButton: '',
			currentActiveButtonTitle: '',

			showModal: false,
			selectedChapters: [],
			search: '',
			page: '',
			searchValue: '',
			chapters: '',

			showError: false,
			error: ''
		}
	},
}
</script>

<style lang='scss'>
.events-page {
	background: #f1f1f1 !important;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__pagination {
		.theme--light.v-pagination .v-pagination__item--active {
			color: #4a4a4a !important;
			background: rgb(222, 222, 222) !important;
			border-radius: 4px;
			height: 30px !important;
			width: 30px !important;
		}

		.theme--light.v-pagination .v-pagination__item--active {
			color: #4a4a4a !important;
			background: rgb(222, 222, 222) !important;
			border-radius: 4px;
			height: 30px;
			width: 30px;
		}

		.v-pagination__item {
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-align: center;
			color: #42a1d8 !important;
			background: none !important;
			box-shadow: none !important;
		}

		.v-pagination__navigation {
			background: none !important;
			box-shadow: none !important;
		}
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__btn-filters {
			color: var(--chip-text-normal) !important;
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;

			background-color: var(--chip-normal-background) !important;

			border-radius: 15px;
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
			margin-right: 15px;

			&-active {
				background-color: var(--chip-selected-background) !important;
				color: var(--chip-text-selected) !important;
			}
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
		}
	}

	@media screen and (max-width: 1264px) {
		&__wrap {
			padding: 20px;
		}
	}
}

.v-btn {
	background-color: var(--accent-color) !important;
	color: white !important;
}
</style>

